import { component } from "picoapp";

export default component((node) => {
  window.addEventListener("option-change:color", (event) => {
    const eventValue = event.detail.value;
    if (eventValue) {
      node.style.backgroundColor = node.getAttribute("data-color2");
    } else {
      node.style.backgroundColor = node.getAttribute("data-color1");
    }
  });
});
